import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import RiskFactorsSummaryListItem from './RiskFactorsSummaryListItem';
import {labels} from '../../../../../util/utils';

function RiskFactorsSummaryList(props) {
	const {riskFactorsList, isThisNotaROMM} = props;

	function getRiskFactorSortedList() {
		return _.orderBy(riskFactorsList, ['riskFactorName'], ['asc']);
	}

	return (
		<>
			<StyledRiskFactorsSummaryList className="StyledRiskFactorsSummaryList">
				{isThisNotaROMM && (
					<li className="AssociatedRiskListLI">
						<span className="styled-risktype-header">{labels.notROMMHeader}</span>
					</li>
				)}
				{riskFactorsList?.length > 0 ? (
					<section className="risktype-list">
						{getRiskFactorSortedList() &&
							getRiskFactorSortedList().length > 0 &&
							getRiskFactorSortedList().map((riskFactor) => (
								<RiskFactorsSummaryListItem
									key={riskFactor.id}
									riskFactor={riskFactor}
									isThisNotaROMM={isThisNotaROMM}
								/>
							))}
					</section>
				) : (
					isThisNotaROMM && (
						<section className="empty-template">
							<span className="no-records">{labels.noRecordsAvailable}</span>
						</section>
					)
				)}
			</StyledRiskFactorsSummaryList>
		</>
	);
}

RiskFactorsSummaryList.propTypes = {
	riskFactorsList: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RiskFactorsSummaryList;

const StyledRiskFactorsSummaryList = styled.ul`
	font-size: var(--px-16);
	margin: var(--px-16);
`;
